import invoiceList from "dummydata/invoiceList";
import { INVOICE_TOTAL } from "redux/actionTypes/actionTypes";
import { DELETE_INVOICE } from "redux/actionTypes/actionTypes";
import { ADD_INVOICE,GET_INVOICE_LIST } from "redux/actionTypes/actionTypes";

const initialState = {
  envelopeList: [],
  envelopeTotal: 0,
};

const envelopeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICE_LIST:
      return {
        ...state,
        envelopeList: action.payload,
      };
      break;
    case ADD_INVOICE:
      return {
        ...state,
        envelopeList: state.invoiceList.concat(action.payload),
      };
      break;
    case DELETE_INVOICE:
      return {
        ...state,
        envelopeList: state.invoiceList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    case INVOICE_TOTAL:
      return {
        ...state,
        envelopeList: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default envelopeReducer;
